/**
 * Bento gradient + 18-palette pickers.
 *
 * V1d's defining trait is bento gradient washes on every card, plus per-card
 * accent colours drawn from the 18-colour palette declared in globals.css.
 * Without these the cards collapse into a generic dark grid.
 *
 * Both pickers hash the slug deterministically so the same ability always
 * gets the same wash + colour pair across renders + reloads.
 */

export const BENTOS = [
  "var(--bento-purple)",
  "var(--bento-cool)",
  "var(--bento-rose)",
  "var(--bento-amber)",
  "var(--bento-mint)",
  "var(--bento-sky)",
  "var(--bento-warm)",
  "var(--bento-slate)",
] as const;

export const PALETTE = [
  "var(--color-palette-indigo)",
  "var(--color-palette-purple)",
  "var(--color-palette-pink)",
  "var(--color-palette-rose)",
  "var(--color-palette-amber)",
  "var(--color-palette-orange)",
  "var(--color-palette-teal)",
  "var(--color-palette-cyan)",
  "var(--color-palette-sky)",
  "var(--color-palette-green)",
  "var(--color-palette-lime)",
  "var(--color-palette-blue)",
  "var(--color-palette-coral)",
  "var(--color-palette-lavender)",
] as const;

function hash(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h;
}

export function pickBento(slug: string): string {
  return BENTOS[hash(slug) % BENTOS.length];
}

export function pickColor(slug: string, override?: string | null): string {
  if (override) return override;
  return PALETTE[hash(slug + "c") % PALETTE.length];
}
